class ImageZoomWrapper extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.openZoom.bind(this));
  }

  openZoom(e) {
    e.preventDefault();
    const fullImageSrc = this.getAttribute("data-full-image");
    if (!fullImageSrc) return;

    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100vw";
    overlay.style.height = "100vh";
    overlay.style.backgroundColor = "rgba(0, 0, 0, 0.85)";
    overlay.style.zIndex = "999999";
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";
    overlay.style.cursor = "zoom-out";
    overlay.style.backdropFilter = "blur(5px)";

    const img = document.createElement("img");
    img.src = fullImageSrc;
    img.style.maxWidth = "90%";
    img.style.maxHeight = "90%";
    img.style.objectFit = "contain";
    img.style.borderRadius = "8px";
    img.style.boxShadow = "0 10px 30px rgba(0,0,0,0.5)";
    img.style.transition = "transform 0.3s ease";
    img.style.userSelect = "none";

    const closeBtn = document.createElement("div");
    closeBtn.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
    closeBtn.classList.add("close-btn");

    overlay.appendChild(img);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    overlay.addEventListener("click", () => {
      document.body.removeChild(overlay);
    });
  }
}

if (!customElements.get("image-zoom-wrapper")) {
  customElements.define("image-zoom-wrapper", ImageZoomWrapper);
}
